<template>
  <b-pagination
    class="mb-0"
    size="md"
    :total-rows="paginator.total_count"
    v-model="page"
    :per-page="paginator.limit"
  >
  </b-pagination>
</template>

<script>
  import replaceAnchorParams from 'helpers/replaceAnchorParams'
  export default {
    props: {
      paginator: {
        type: Object,
        required: true
      },
      value: {
        type: Number,
        required: true
      }
    },
    computed: {
      page: {
        get: function () {
          return this.value
        },
        set: function (value) {
          window.location.href = replaceAnchorParams(window.location.href, 'page', value)
          this.$emit('input', value)
        }
      }
    },
    watch: {
      '$route' (to, from) {
        this.anchorPaginate()
      }
    },
    name: 'AdminPagination',
    methods: {
      anchorPaginate () {
        let url = window.location.href.split('#')
        if (url[1]) {
          let params = url[1].split('&')
          params.forEach(item => {
            let value = item.split('=')
            if (value[0] === 'page') {
              let page = parseInt(value[1])
              this.page = page
            }
          })
        }
      }
    },
    created () {
      this.anchorPaginate()
    }
  }
</script>



// WEBPACK FOOTER //
// AdminPagination.vue?7e7464e0